import { CreateHelpModulePayloadType, GetHelpModulePayloadType, UpdateHelpModulePayloadType } from "../commonTypes/helpModuleTypes";
import { getCSRFToken } from "../utils/commonFunctions";
import { getData, postData } from "./apiInstance";
import { AxiosResponse } from "axios";

export async function createHelpModuleListApi(
  data: CreateHelpModulePayloadType
): Promise<AxiosResponse> {
  const { token, title, description, attachments, video_link } = data;
  return await postData(
    `/master-module/help/add`,
    {  title, description, attachments ,video_link},
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken()
      },
    }
  );
}
export async function getHelpModuleListApi(
    data: GetHelpModulePayloadType
  ): Promise<AxiosResponse> {
    const { token ,search_term,
      limit,offset} = data;
  
      let finalParams = {
      limit,
      offset,
      ...(search_term && search_term.length  > 0 && { search_term: search_term }),
    };
    return await getData(`/master-module/help/list`, {
      params: {
       ...finalParams,
      },
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
      },
    });
  }

export async function updateHelpModuleApi(data:UpdateHelpModulePayloadType
): Promise<AxiosResponse> {
  const {token, _id , title, description, attachments,video_link }= data
  return await postData(`/master-module/help/update`, {_id, title, description , attachments,video_link},{
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken()
    },
  });
}






  
